<template>
  <div class="user-view-container">
    <div>
      <v-container fluid class="pa-0">
        <v-row no-gutters>
          <v-col cols="12" md="8" lg="6" offset-md="2" offset-lg="3">
            <v-card class="ma-4 user-view-card" flat>
              <div class="profile-panel-layout">
                <!-- User Header Section -->
                <v-card class="px-4 py-4 profile-panel-header" width="100%" flat tile>
                  <div style="display: flex;">
                    <span>
                      <v-avatar size="36px" v-if="$auth.user && $auth.user.picture" class="pl-4 pr-7">
                        <img small :src="$auth.user.picture" alt="User's profile picture" />
                      </v-avatar>
                      <v-avatar size="36px" v-else color="primary" class="pr-7">
                        <v-icon dark>
                          mdi-account-circle
                        </v-icon>
                      </v-avatar>
                      <span class="title font-weight-bold subtitle-1">
                        {{ $auth.user && $auth.user.name ? $auth.user.name : 'My Profile' }}
                      </span>
                    </span>
                    <div class="flex-grow-1"></div>
                  </div>
                </v-card>
                
                <v-divider></v-divider>
                
                <!-- User Profile Component (scrollable mid section) -->
                <div class="profile-panel-mid">
                  <user-profile />
                </div>
                
                <v-divider></v-divider>
                
                <!-- Login Component (for logout functionality) -->
                <div class="profile-panel-footer">
                  <login :menu="login_menu" :authenticated="authenticated" @close="handleClose" />
                </div>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </div>
  </div>
</template>

<script>
import UserProfile from "@/components/UserProfile.vue";
import Login from "@/components/Login.vue";

export default {
  name: "User",
  components: {
    UserProfile,
    Login
  },
  data() {
    return {
      login_menu: true,
      authenticated: true
    };
  },
  mounted() {
    // Check authentication status
    if (this.$auth && this.$auth.isAuthenticated) {
      this.authenticated = true;
    } else {
      this.authenticated = false;
    }
  },
  methods: {
    handleClose() {
      // Handle close event if needed
      // Could navigate away or handle logout
    }
  }
};
</script>

<style scoped>
.user-view-container {
  min-height: 100vh;
  background-color: #F4F4F4;
}

.user-view-card {
  height: calc(100vh - 32px);
  max-height: calc(100vh - 32px);
}

.user-view-card ::v-deep .profile-panel-layout {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
}

.user-view-card ::v-deep .profile-panel-header {
  flex-shrink: 0;
}

.user-view-card ::v-deep .profile-panel-mid {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
}

.user-view-card ::v-deep .profile-panel-footer {
  flex-shrink: 0;
}

::v-deep .v-card {
  background-color: #ffffff;
}
</style>
